// src/components/EventsAttended.js — "Events" section for a contact or firm
// profile: every event the record is on the attendee list of. For a firm,
// also events its people attended, marked "via <name>". The other half of the attendee links on EventDetail.js.
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import api from '../lib/api'
import { dateRange, oneLine } from '../lib/searchTypes'

export default function EventsAttended({ contactId, firmId }) {
  const params = contactId ? { contact_id: contactId } : { firm_id: firmId }
  const { data, isLoading } = useQuery({
    queryKey: ['events-attended', params],
    queryFn: () => api.get('/api/events', { params }).then(r => r.data.data ?? []),
  })

  return (
    <div>
      <div style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase',
        letterSpacing: '0.06em', color: 'var(--text-secondary)', marginBottom: 8 }}>
        Events
      </div>
      {isLoading ? (
        <div className="spinner" />
      ) : !data?.length ? (
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>No events recorded.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {data.map(ev => (
            <div key={ev.event_id} style={{ display: 'flex', gap: 8, alignItems: 'baseline', fontSize: 13, flexWrap: 'wrap' }}>
              <span className="badge badge-blue">{ev.event_type}</span>
              <Link to={`/events/${ev.event_id}`} style={{ color: 'var(--blue-text)', fontWeight: 500 }}>{ev.name}</Link>
              <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>
                {[ev.start_date && dateRange(ev.start_date, ev.end_date), oneLine(ev.location)].filter(Boolean).join(' · ')}
                {ev.via?.length ? ` · via ${ev.via.join(', ')}` : ''}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
